export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7126.5f1a0cf8.jpg";